export const roleSettings = {
    superAdmin:{
        sideMenu: {
            'dashboard': {
                hide: false,
                disable: false,
                lock: false,
                children: {
                    'awv': {
                        hide: true,
                        disable: true,
                        lock: true
                    },
                    'ccm': {
                        hide: true,
                        disable: true,
                        lock: true
                    },
                    'bh': {
                        hide: true,
                        disable: true,
                        lock: true
                    },
                    'rpm': {
                        hide: true,
                        disable: true,
                        lock: true
                    },
                    'add-dashboard': {
                        hide: false,
                        disable: false,
                        lock: false
                    }
                }
            },
            'patient': {
                hide: false,
                disable: false,
                lock: false
            },
            'rewards': {
                hide: false,
                disable: false,
                lock: false
            },
            'communication': {
                hide: true,
                disable: true,
                lock: true
            },
            'activities': {
                hide: true,
                disable: true,
                lock: true
            },
            'knowledge_base': {
                hide: true,
                disable: true,
                lock: true
            },
            'report': {
                hide: false,
                disable: false,
                lock: false
            },
            'insights': {
                hide: true,
                disable: false,
                lock: false
            },
            'social-determinants': {
                hide: true,
                disable: true,
                lock: true
            }	
        },
        patientDetail: {
            cards:{
                'profile':{
                    hide: true,
                    disable: false,
                    lock: false,
                    hideContent: false
                },
                'riskAssessment':{
                    hide: true,
                    disable: false,
                    lock: true,
                    hideContent: true
                },
                'socialDeterminants':{
                    hide: true,
                    disable: false,
                    lock: true,
                    hideContent: true
                },
                'preferredChannels':{
                    hide: true,
                    disable: false,
                    lock: true,
                    hideContent: true
                }
            },
            tab: {
                'profile': {
                    hide: false,
                    disable: false,
                    lock: false
                },
                'assessment': {
                    hide: false,
                    disable: false,
                    lock: false
                },
                'care_plan': {
                    hide: true,
                    disable: true,
                    lock: true
                },
                'patient_engagement': {
                    hide: false,
                    disable: false,
                    lock: false
                },
                'workflow': {
                    hide: false,
                    disable: false,
                    lock: false
                },
                'appointment': {
                    hide: false,
                    disable: true,
                    lock: true
                },
                'documents':{
                    hide: false,
                    disable: false,
                    lock: false
                },
                'social_determinants': {
                    hide: true,
                    disable: true,
                    lock: true
                },
                'rewards': {
                    hide: true,
                    disable: true,
                    lock: true
                }
            }
        }
    }
}